import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';
import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';
import { getBuyerId } from 'dibs-cookie-jar';
import getRelayEnvironment from '../relayClientEnvironment';
import { localStorage } from 'dibs-browser-storage';
import isPageType from './isPageType';
import { PAGE_TYPE } from './pageConstants';

const LAST_SHOWN_TOKEN = 'last_shown_trade_onboarding_modal';
const MODAL_TYPE = 'tradeOnboardingModal';
const CONTAINER_CLASSNAME = 'tradeSourcingCTAModalContainer';

export const ORIGIN_SOLD = 'Sold PDP';
export const ORIGIN_HOLD = 'Hold PDP';
export const ORIGIN_FAVORITE = 'Post Favorite';
export const ORIGIN_FOLDER = 'Post Folder';
export const LABEL_PDP = 'pdp';
export const LABEL_SEARCH_BROWSE = 'search/browse';

export const getModalType = () => MODAL_TYPE;
export const hasSeenModal = () => !!localStorage.getItem(LAST_SHOWN_TOKEN);
export const markModalShown = () => localStorage.setItem(LAST_SHOWN_TOKEN, Date.now());

export const getContainerElement = () => {
    let containerElement = document.querySelector(`.${CONTAINER_CLASSNAME}`);
    if (!containerElement) {
        containerElement = document.createElement('div');
        containerElement.classList.add(CONTAINER_CLASSNAME);
        document.body.appendChild(containerElement);
    }
    return containerElement;
};

const query = graphql`
    query tradeOnboardingHelper_Query($userId: String!) {
        viewer {
            user(userId: $userId) {
                isVerifiedTrade: hasPermission(name: "B_NET_PRICE")
                profile {
                    email
                }
            }
        }
    }
`;

export const fetchTradeUserData = () => {
    const userId = getBuyerId(document.cookie);

    if (!userId) {
        return Promise.resolve(false);
    }

    return new Promise((resolve, reject) => {
        fetchQuery(getRelayEnvironment(), query, {
            userId,
        })
            .then(data => {
                const userData = get(data, 'viewer.user') || {};
                resolve({
                    isVerifiedTrade: get(userData, 'isVerifiedTrade'),
                    email: get(userData, 'profile.email'),
                });
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const loadOnboardingModal = options => {
    const chatUtils = require('./chat').default;

    return new Promise((resolve, reject) => {
        import(/* webpackChunkName: "tradeOnboarding" */
        'dibs-trade-onboarding')
            .then(({ onboardingModal }) => {
                const modalOptions = {
                    ...options,
                    onSendSourcingDataSuccess: () => chatUtils.track.sourcingRequestSubmitted(),
                };
                const { Modal } = onboardingModal(modalOptions);
                ReactDOM.render(React.createElement(Modal), getContainerElement());
                markModalShown();
                resolve(true);
            })
            .catch(reject);
    });
};

export const loadOnboardingModalWithOrigin = requestOrigin => {
    if (hasSeenModal()) {
        return;
    }

    const label = isPageType(PAGE_TYPE.PDP) ? LABEL_PDP : LABEL_SEARCH_BROWSE;

    fetchTradeUserData().then(({ email, isVerifiedTrade }) => {
        if (isVerifiedTrade) {
            loadOnboardingModal({
                buyerEmail: email,
                requestOrigin,
                trackingLabel: `modal - ${label}`,
            });
        }
    });
};

export const loadSourcingModal = options => {
    const chatUtils = require('./chat').default;

    return new Promise((resolve, reject) => {
        import(/* webpackChunkName: "tradeOnboarding" */
        'dibs-trade-onboarding')
            .then(({ sourcingModal }) => {
                const modalOptions = {
                    ...options,
                    onSendSourcingDataSuccess: () => chatUtils.track.sourcingRequestSubmitted(),
                };
                const { SourcingModal } = sourcingModal(modalOptions);
                ReactDOM.render(React.createElement(SourcingModal), getContainerElement());
                resolve(true);
            })
            .catch(reject);
    });
};
